const REGEX = /^.*\.(pdf|PDF|png|PNG|jpeg|JPEG|jpg|JPG|gif|GIF)$/;

export const extensionFinder = (file: string): string | null => {
  const matches = REGEX.exec(file);

  if (!matches) return null;

  return matches[1].toLowerCase();
};
